import axios from "axios";
import {Link, LoaderFunctionArgs, useLoaderData} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {DataGrid, GridColDef, GridToolbarContainer, GridToolbarQuickFilter} from "@mui/x-data-grid";
import {Button, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Modal, Select, TextField} from "@mui/material";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import {NPC} from "../../../server/Plot";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const npcColumns: GridColDef[] = [
    {
        field: 'name', headerName: 'Face Role', headerAlign: "center", renderCell: (params) => (
            <Link to={'/npc/' + params.row.id}>{params.value}</Link>
        ), minWidth:300,
    }
]

export async function loadNPCForId(id: number): Promise<any> {
    const apiEndpoint = "/plot/npc/" + id
    return await axios.get(apiEndpoint).then(({data}) => {
        return data;
    })
}


export async function loadNPCList() {
    const apiEndpoint = "/plot/npcs/faceroles"
    return await axios.get(apiEndpoint).then(({data}) => {
        console.log(data)
        return data as NPC[];

    })
}

export function FaceList() {
    const [faceroles, setFaceroles] = React.useState([]);
    const [newNPCOpen, setNewNPCOpen] = React.useState(false);
    const [nameError, setNameError] = React.useState<string | null>(null);

    useEffect(() => {
        axios.get("/plot/npcs/faceroles").then(response => {
            setFaceroles(response.data)
        })
    }, [])

    const handleOpenNewNPC = () => setNewNPCOpen(true);
    const handleCloseNewNPC = () => { setNewNPCOpen(false); setNameError(null); };

    let newNPC = {name: "", type: ""}

    async function createNewNPC() {
        try {
            const {data} = await axios.post("/plot/npcs/", newNPC)
            handleCloseNewNPC()
            newNPC = {name: "", type: ""}
            return data;
        } catch (err: any) {
            if (err?.response?.status === 409) {
                setNameError(err.response.data?.error ?? 'An NPC with this name already exists.')
            }
        }
    }

    function QuickFilterToolBar() {
        return (
            <GridToolbarContainer>
                <GridToolbarQuickFilter/>
                <Button onClick={handleOpenNewNPC}><PostAddIcon/></Button>
            </GridToolbarContainer>
        )
    }

    return <React.Fragment>
        <Typography variant="h4" component="h4" align="center">Face Roles</Typography>

        <DataGrid slots={{toolbar: QuickFilterToolBar}}
                  autoHeight={true}
                  rows={faceroles}
                  columns={npcColumns}
                  getRowId={(row) => row.id}
                  density={"compact"}
                  initialState={{
                      pagination: {
                          paginationModel: {
                              pageSize: 24,
                          },
                      },
                  }}
        />


        <Modal
            open={newNPCOpen}
            onClose={handleCloseNewNPC}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyle}>
                <Typography id="modal-modal-title" align={"center"} variant="h5" component="h4">
                    Create New NPC
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12}><TextField fullWidth id='newNPCName' label='Name or Placeholder'
                                                  error={!!nameError}
                                                  helperText={nameError ?? ''}
                                                  onChange={(ev) => {
                                                      newNPC.name = ev.target.value
                                                      if (nameError) setNameError(null)
                                                  }}/></Grid>
                    <Grid item xs={12}> <FormControl sx={{m: 1, minWidth: 120}}>
                        <InputLabel id="type-helper-label">NPC Type</InputLabel>
                        <Select
                            labelId="type-helper-label"
                            id="newNPCType"
                            label="Type"
                            onChange={(ev) => {
                                newNPC.type = ev.target.value as string
                            }}
                        >
                            <MenuItem value={'NPC'}>Named NPC</MenuItem>
                            <MenuItem value={'FACEROLE'}>Face Role</MenuItem>
                        </Select>
                        <FormHelperText>Select NPC Type</FormHelperText>
                    </FormControl>
                    </Grid>
                </Grid>

                <Container align={"center"}><Button onClick={createNewNPC} disabled={!!nameError}>Submit</Button></Container>
            </Box>
        </Modal>
    </React.Fragment>

}